/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { withRouter, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import logoSrc from '../../assets/logo.jpg';
import authActions from '../../actions/auth/auth';
import './welcome.less';

const getEnvironmentLabel = () => {
  const apiEnv = process.env.API_ENV;

  // Debug: sprawdź wartość zmiennej (można usunąć po weryfikacji)
  // eslint-disable-next-line no-console
  console.log('API_ENV value:', apiEnv);

  // Jeśli API_ENV to 'production', nie pokazuj badge'a
  if (!apiEnv || apiEnv === 'production') {
    return null;
  }

  // Mapowanie wartości API_ENV na etykiety
  const envMap = {
    local: { label: 'ŚRODOWISKO LOKALNE', color: 'default' },
    stage: { label: 'ŚRODOWISKO STAGE', color: 'default' },
  };

  return envMap[apiEnv.toLowerCase()] || { label: `ŚRODOWISKO: ${apiEnv.toUpperCase()}`, color: 'secondary' };
};

function Welcome({ history }) {

  const dispatch = useDispatch();
  const location = useLocation();
  const envConfig = getEnvironmentLabel();

  useEffect(()=>{

    const searchParams = new URLSearchParams(location.search);
    const deviceToken = searchParams.get('t');

    if(deviceToken != null){
      dispatch(authActions.setDeviceToken(deviceToken));
    }

  },[dispatch,location])


  return (
    <div className="welcome">
      {envConfig && (
        <div className="environment-badge">
          <Chip
            label={envConfig.label}
            color={envConfig.color}
            size="medium"
          />
        </div>
      )}
      <img className="logo" src={logoSrc} alt="uni-gaz logo" />
      <Button variant="outlined" size="large" color="primary" onClick={() => history.push('/log-in')}>
        Zaloguj się
        &nbsp;
        <ExitToAppIcon />
      </Button>
      <div className="welcome-label">Jesteś tu pierwszy raz?</div>
      <Button variant="outlined" size="large" color="primary" onClick={() => history.push('/register')}>
        Zarejestruj się
      </Button>
    </div>
  );
}

Welcome.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default withRouter(Welcome);
